import { Link } from 'expo-router'
import { Button } from './ui/button'
import { Home } from 'lucide-react'

export function Header() {
  return (
    <header className="border-b bg-background p-4">
      <div className="max-w-3xl mx-auto flex items-center">
        <Link href="/">
          <Button variant="secondary" size="sm">
            <Home className="w-4 h-4 mr-2" />
            Home
          </Button>
        </Link>
      </div>
    </header>
  )
}
